import React, { Dispatch, FC, useMemo } from 'react';
import { HeaderGroup } from 'react-table';
import * as classnames from 'classnames';

import { getColumnSorting } from 'helpers/getColumnSorting';
import { SortColumnIndicator } from './sort-column-indicator';
import { IColumnSortingInfo, IHeaderGroup } from 'types/table';

import styles from './styles.module.css';

interface IColumnHeaderProps {
  column: HeaderGroup<Record<string, unknown>>;
  columnsSorting?: IColumnSortingInfo[];
  sortColumnData?: Dispatch<IColumnSortingInfo>;
}

export const ColumnHeader: FC<IColumnHeaderProps> = (props) => {
  const { column, columnsSorting, sortColumnData } = props;

  const { isSortable, sortBy } = useMemo(() => {
    const sortingInfo = columnsSorting?.find((sortingInfo) => sortingInfo.id === column.id);

    return { sortBy: sortingInfo?.sortBy || null, isSortable: !!sortingInfo };
  }, [columnsSorting]);

  const cellClassname = classnames(styles.th, { [styles.sortable]: isSortable });

  const handleSorting = () => {
    if (isSortable && sortColumnData) {
      sortColumnData({ id: column.id, sortBy: getColumnSorting(sortBy) });
    }
  };

  const getHeaderProps = (column: IHeaderGroup) => ({
    ...column.getHeaderProps([{ style: { ...(column.isFlexUnset && { flex: 'unset' }) } }]),
  });

  return (
    <div {...getHeaderProps(column)} className={cellClassname} onClick={handleSorting}>
      <span>
        {column.render('Header')}
        {isSortable && <SortColumnIndicator sortBy={sortBy} />}
      </span>
    </div>
  );
};
